var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from 'react';
import { DropdownContext } from './DropdownContext';
var Dropdown = /** @class */ (function (_super) {
    __extends(Dropdown, _super);
    function Dropdown(props) {
        var _this = _super.call(this, props) || this;
        _this.getContainer = function () {
            return _this._containerRef.current;
        };
        _this.toggle = function (e) {
            var disabled = _this.props.disabled;
            var isOpen = _this.state.isOpen;
            if (disabled) {
                return e && e.preventDefault();
            }
            _this.setState({ isOpen: !isOpen });
        };
        _this.getContextValue = function () {
            var _a = _this.props, direction = _a.direction, disabled = _a.disabled, id = _a.id;
            var isOpen = _this.state.isOpen;
            return {
                toggle: _this.toggle,
                isOpen: isOpen,
                direction: direction ? direction : 'right-start',
                disabled: disabled,
                containerRef: _this._containerRef,
                id: id,
            };
        };
        _this._containerRef = React.createRef();
        _this.state = {
            isOpen: false,
        };
        return _this;
    }
    Dropdown.prototype.componentDidMount = function () {
        this.getContainer();
    };
    Dropdown.prototype.render = function () {
        var _a = this.props, children = _a.children, hover = _a.hover;
        return (React.createElement(DropdownContext.Provider, { value: this.getContextValue() },
            React.createElement("div", { ref: this._containerRef, className: 'gr-dropdown ' + (hover ? 'hover-' + hover : '') }, children)));
    };
    return Dropdown;
}(Component));
export { Dropdown };
//# sourceMappingURL=Dropdown.js.map